import { isPdfDriveItem } from './shippingLabelHeuristic';

/**
 * In-memory handoff: Smoke Drive (or Packers) → Printing Toolkit Labels.
 * Passes the PDF file bytes — not a public download link — into the matcher.
 */

/** @type {{ blob: Blob, fileName: string, driveItemId?: string, source?: string }|null} */
let pending = null;

/**
 * @param {{ blob: Blob, fileName?: string, driveItemId?: string, source?: string }} payload
 */
export function setShippingLabelPdfHandoff(payload) {
    if (!(payload?.blob instanceof Blob) || !payload.blob.size) {
        throw new Error('A PDF file is required for shipping-label matching.');
    }
    pending = {
        blob: payload.blob,
        fileName: String(payload.fileName || 'shipping-labels.pdf').trim() || 'shipping-labels.pdf',
        driveItemId: payload.driveItemId ? String(payload.driveItemId) : undefined,
        source: payload.source ? String(payload.source) : 'smoke-drive',
    };
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('lsc:shipping-label-pdf-handoff'));
    }
}

/**
 * @returns {{ blob: Blob, fileName: string, driveItemId?: string, source?: string }|null}
 */
export function peekShippingLabelPdfHandoff() {
    return pending;
}

/**
 * @returns {{ blob: Blob, fileName: string, driveItemId?: string, source?: string }|null}
 */
export function consumeShippingLabelPdfHandoff() {
    const next = pending;
    pending = null;
    return next;
}

export function clearShippingLabelPdfHandoff() {
    pending = null;
}

/**
 * @param {{ name?: string, originalFileName?: string, contentType?: string, type?: string }} item
 */
export function isShippingLabelPdfDriveItem(item) {
  return isPdfDriveItem(item);
}
